<script setup lang="ts">
import type { BreadcrumbProps } from '#seo-utils/app/composables/useBreadcrumbItems'

definePageMeta({
  layout: false,
  colorMode: 'light',
  theme: 'blurple',
  name: 'info-page',
})

const route = useRoute<'info-page'>()

const { data: article, suspense } = useArticle(() => route.params.slug, '/tilleggsopplysninger')

await suspense()

if (!article.value) {
  throw createError({
    statusCode: 404,
    statusMessage: 'Siden finnes ikke',
    fatal: true,
    data: {
      navigationContext: 'marketing' satisfies NavigationContext,
    },
  })
}

const { $htmlToText } = useNuxtApp()

const title = computed(() => $htmlToText(article.value?.components?.title))

const breadcrumbs: BreadcrumbProps['overrides'] = computed(() => {
  return [
    undefined,
    false,
    title.value
      ? {
          label: title.value,
          to: route.path,
        }
      : undefined,
  ]
})

useHead({
  title,
  bodyAttrs: {
    class: 'bg-blurple-500',
  },
})
</script>

<template>
  <NuxtLayout name="nettbutikk-dark" :overrides="breadcrumbs">
    <NettbutikkArticle v-if="article" :article="article" class="dark-mode" />
  </NuxtLayout>
</template>
